// Copyright (c) Move Closer 2022.

import { Component, Vue } from 'vue-property-decorator'

import { UserModel } from '../../../auth/shared'

import { IUserMixin } from '../contracts'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
@Component<UserMixin>({
  name: 'UserMixin'
})
export class UserMixin extends Vue implements IUserMixin {
  // Fixme -> not created store yet
  public get fullName (): string {
    return this.$store.getters['profile/fullName']
  }

  public get user (): UserModel | null {
    return this.$store.getters['profile/user']
  }

  public setUser (user: UserModel | null) {
    this.$store.commit('profile/SET_USER', user)
  }
}
